var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isAlertActive)?_c('AlertDialog',{attrs:{"alertMsg":_vm.alertMsg,"buttonLabel":"確認"},on:{"close":function($event){return _vm.$_closeAlertDialog()}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }